
import { useCallback } from 'react';

interface UseExerciseUIStateProps {
  setShowAnswer: React.Dispatch<React.SetStateAction<boolean>>;
  setUserInput: (input: string) => void;
  setIsInputCorrect: React.Dispatch<React.SetStateAction<boolean | null>>;
  resetFlipState?: () => void;
}

/**
 * Hook to manage UI state for exercises
 */
export const useExerciseUIState = ({
  setShowAnswer,
  setUserInput,
  setIsInputCorrect,
  resetFlipState
}: UseExerciseUIStateProps) => {
  
  // Reset UI state for next exercise
  const resetUIState = useCallback(() => {
    console.log(`🔄 [resetUIState] Resetting UI state for user input`);
    setShowAnswer(false);
    setUserInput('');
    setIsInputCorrect(null);
    
    if (resetFlipState) {
      resetFlipState();
    }
  }, [setShowAnswer, setUserInput, setIsInputCorrect, resetFlipState]);
  
  return {
    resetUIState
  };
};
